import { PracticesList, PracticesProps } from "./PracticesList";

export type PracticesLayoutProps = PracticesProps & {
  titleStyles?: string;
}

export const PracticesLayout: React.FC<PracticesLayoutProps> = ({
  practices,
  listContainerStyles,
  listItemsStyles,
  keyPrefix,
  titleStyles = "text-xs text-slate-600 my-3 ml-3",
}) => (
  <div className="flex flex-col max-w-lg">
    <span className={titleStyles}>Practicas:</span>
    <PracticesList
      practices={practices}
      listContainerStyles={listContainerStyles}
      listItemsStyles={listItemsStyles}
      keyPrefix={keyPrefix}
    />
  </div>
);
